import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Validators from './validators'
import { BaseManipStateFn, BaseTableState } from './base'
import { observable } from 'mobx'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    prepareNew () {
      if (!this.record.has('id')) {
        this.record.set('control_timestamp', Math.round(new Date().getTime()))
      }

      this.record.set('pprolls_conditions', [])
      this.record.set('pprolls_items', [])
    }

    beforeSave (entity) {
      entity.name = entity.name ? entity.name.trim() : null
      super.beforeSave(entity)
    }

    requiredOptions = [
      'Countries',
      'FlyPrivateCategoryTypes',
      'FlyPrivatePlatforms',
      'FlyprivateCategories',
      'PricingTiers',
      linkConst.LOAD_OPTIONS.films,
      linkConst.LOAD_OPTIONS.flyprivate_all_pricings,
      linkConst.LOAD_OPTIONS.flyprivate_all_tiers,
      linkConst.LOAD_OPTIONS.flyprivate_categories_settings,
      linkConst.LOAD_OPTIONS.flyprivate_homepage_settings,
      linkConst.LOAD_OPTIONS.pprolls_uploads
    ]

    timeRestriction = linkConst.LINK_PPROLLS_SETUP
    createtitle = store.__(linkConst.LINK_PPROLLS_SETUP_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_PPROLLS_SETUP_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    @observable platformFilter = null

    subentities = {
      pprolls_conditions: store.createEmbededEntityState({
        attrs: [
          'id',
          'condition_table',
          'condition_key'
        ],
        titles: [
          store.__('ID'),
          store.__('Condition'),
          store.__('Key')
        ],
        _sortField: 'id',
        noSort: [],
        validators: {
          condition_table: [Validators.isMandatory(store)],
          condition_key: [Validators.isMandatory(store)],
          _global: (vals, values) => {}
        }
      }),
      pprolls_items: store.createEmbededEntityState({
        attrs: [
          'id',
          's3uploads_id',
          'position',
          'use_for',
          'regions',
          'valid_from',
          'valid_to'
        ],
        titles: [
          store.__('ID'),
          store.__('File'),
          store.__('Play position'),
          store.__('Play for'),
          store.__('Play in regions'),
          store.__('Play from'),
          store.__('Play to')
        ],
        lastSave: 'pprolls_items',
        timeRestriction: 'pprolls_items',
        _sortField: 'id',
        noSort: [],
        validators: {
          regions: Validators.isMandatory(store),
          valid_from: Validators.isValidFromTo(store),
          valid_to: Validators.isValidFromTo(store)
        }
      })
    }

    validators = {
      name: [Validators.isMandatory(store)],
      valid_from: [
        Validators.isMandatoryDate(store),
        Validators.isValidFromTo(store)
      ],
      valid_to: [
        Validators.isMandatoryDate(store),
        Validators.isValidFromTo(store)
      ]
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id',
      'name',
      'valid_from',
      'valid_to',
      'condition_table',
      'condition_key',
      's3_filename',
      'position',
      'use_for',
      'regions',
      'items_valid_from',
      'items_valid_to'
    ]

    headertitles = [
      store.__('ID'),
      store.__('Name'),
      store.__('Valid from'),
      store.__('Valid to'),
      store.__('Condition'),
      store.__('Key'),
      store.__('File'),
      store.__('Play position'),
      store.__('Play for'),
      store.__('Play in regions'),
      store.__('Play from'),
      store.__('Play to')
    ]

    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_PPROLLS_SETUP]
    noSort= ['condition_key', 's3_filename']

    title = store.__(linkConst.LINK_PPROLLS_SETUP_TITLE)
    requiredOptions = [
      'Countries',
      'FlyPrivateCategoryTypes',
      'FlyPrivatePlatforms',
      'FlyprivateCategories',
      'PricingTiers',
      linkConst.LOAD_OPTIONS.films,
      linkConst.LOAD_OPTIONS.flyprivate_all_pricings,
      linkConst.LOAD_OPTIONS.flyprivate_all_tiers,
      linkConst.LOAD_OPTIONS.flyprivate_categories_settings,
      linkConst.LOAD_OPTIONS.flyprivate_homepage_settings,
      linkConst.LOAD_OPTIONS.pprolls_uploads
    ]

    disableAttrs = {
      disable: [],
      hide: [
        'id',
        'name',
        'valid_from',
        'valid_to']
    }

    init () {
      return super.init()
    }
  }

  return { ManipState, TableState }
}
